import "./App.css";
import { Route, Switch, Link, useHistory, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const App = () => {
  const schema = yup.object().shape({
    nome: yup.string().required("Campo Obrigatório"),
    idade: yup.number().required("Campo Obrigatório"),
    email: yup.string().email("Email invalido").required("Campo Obrigatório"),
    senha: yup
      .string()
      .min(5, "Minímo 5 digitos")
      .required("Campo Obrigatório"),
    senhaConfirm: yup.string().oneOf([yup.ref("senha")], "Senhas Diferentes"),
  });
  const { register, unregister, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const handleForm = (data) => {
    console.log(data);
  };

  const keys = Object.keys(errors);

  return (
    <div className="App">
      <form onSubmit={handleSubmit(handleForm)}>
        <label htmlFor="nome">Nome:</label>
        <input id="nome" name="nome" ref={register}></input>
        <label htmlFor="idade">Idade:</label>
        <input id="idade" type="number" name="idade" ref={register}></input>
        <label htmlFor="email">Email:</label>
        <input id="email" name="email" ref={register}></input>
        <label htmlFor="senha">Senha:</label>
        <input id="senha" name="senha" ref={register}></input>
        <label htmlFor="senhaConfirm">Confirmar Senha:</label>
        <input id="senhaConfirm" name="senhaConfirm" ref={register}></input>
        <button>Enviar</button>
      </form>
      <p>
        {keys.map((msg, index) => (
          <p key={index}>{errors[msg]?.message}</p>
        ))}
      </p>
    </div>
  );
};

export default App;
